import { useMainStore } from "@/stores/main";
import axios from "axios";
import { API } from "@/utils/api/api_paths";
import { useQuestionsStore } from "@/stores/questions";
import { BasicQuestionKey, QuestionType, type Question } from "@/types/questions";
import { useHealthStore } from "@/stores/health";
import { getCookie } from "@/utils/functions";

export const setIPLocationCountry = async () => {
  const mainStore = useMainStore();
  const cloudflareCookieCountry = getCookie("cf_country");
  const cloudflareCookieIp = getCookie("cf_ip");

  if (cloudflareCookieCountry && cloudflareCookieIp) {
    mainStore.setIPLocationCountry({
      code: cloudflareCookieCountry,
      name: cloudflareCookieCountry,
      ip: cloudflareCookieIp,
      currency: "",
    });
    return;
  }

  try {
    const res: any = await axios.get(API.IP_REGISTRY);
    const countryCode: string = res.data.location.country.code;
    const countryName: string = res.data.location.country.name;
    const ip: string = res.data.ip;
    const countryCurrency: string = res.data.currency.code;
    mainStore.setIPLocationCountry({ code: countryCode, name: countryName, currency: countryCurrency, ip });
  } catch (err) {
    console.error("Error fetching IP location data, ", err);
  }
  return true;
};

export const adaptQuestionsType = () => {
  const mainStore = useMainStore();
  if (!mainStore.isLocationUSA) return true;

  const questStore = useQuestionsStore();
  const heightQuestion = questStore.basicStore.questions.find((q: Question) => q.key === BasicQuestionKey.HEIGHT);
  heightQuestion!.type = QuestionType.NUMBER_HEIGHT_USA;

  return true;
};

export const setDataFromStorage = () => {
  const qStore = useQuestionsStore();

  qStore.loadAnswersFromStorage();
  qStore.loadQuestionsFromStorage();
  return true;
};

export const setHealthGoalsFromUrl = (route: any) => {
  if (!route.query.hg) return true;
  const concerns = route.query.hg.split(",");
  const healthStore = useHealthStore();
  healthStore.setHealthConcernsFromUrl(concerns);
  return true;
};
